import { Controller } from "@hotwired/stimulus"
import * as Routes from "routes"

export default class extends Controller {
  static values = {
    banner: String,
  }

  dismiss() {
    if (this.bannerValue !== "price_increase") {
      return
    }

    $(this.element).fadeOut()

    $.ajax({
      method: "POST",
      url: Routes.price_increase_banner_dismissed_account_invoices_path(),
    })
  }
}
